<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-用户中心
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
        <el-form size="small" :model="curItem" label-width="100px">
              <el-form-item label="昵称字体颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.nicknameColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'nicknameColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>

             <el-form-item label="手机号字体颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.mobileColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'mobileColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>


              <el-form-item label="修改资料字体颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.infoColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'infoColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>

                    <el-form-item label="等级背景颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.gradeColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'gradeColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>

                     <el-form-item label="等级字体颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.gradefontColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'gradefontColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>


              <el-form-item label="未登录字体颜色：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.nologinColor"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'nologinColor', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>


                <el-form-item label="背景颜色一：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.bgColor1"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'bgColor1', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>


                  <el-form-item label="背景颜色二：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.bgColor2"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'bgColor2', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>

                    <el-form-item label="背景颜色三：">
                <div class="d-s-c">
                  <el-color-picker v-model="curItem.style.bgColor3"></el-color-picker>
                  <el-button
                    type="button"
                    style="margin-left: 10px"
                    @click.stop="
                      $parent.onEditorResetColor(curItem.style, 'bgColor3', '#ffffff')
                    "
                    >重置
                  </el-button>
                </div>
            </el-form-item>


            
          <el-form-item label="背景图">
            <div>
              <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
              <img :src="curItem.params.bg_image" class="mt10" width="120px;" style='border:1px dashed #999;'  />
            </div>
         </el-form-item>

               <el-form-item label="默认头像">
            <div>
              <el-button type="primary" @click="openUpload(2)">上传图片</el-button>
              <img :src="curItem.params.mr_image" class="mt10" width="120px;" style='border:1px dashed #999;'  />
            </div>
         </el-form-item>


          </el-form>
    </div>

      <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  export default {
     components: {
      Upload,

    },
    data() {
      return {
          upload_type:1,
          isupload:false,
      };
    },
    props: ['curItem'],
    methods: {
      openUpload(e) {
        this.upload_type = e;
  
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {

        if (e != null && e.length > 0) {
          if(  this.upload_type  == 1){
             this.curItem.params.bg_image = e[0].file_path;
          }else if(this.upload_type == 2){
            this.curItem.params.mr_image =  e[0].file_path;
          }
        }
      
        this.isupload = false;
      },


    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/UserInfo.vue